module.exports = __webpack_public_path__ + "media/native-apps/globalgo-6f847f5d.webp";